import type { Account } from "@/Types";

export const exampleAccount: Account = {
  id: "1",
  avatarStyle: "identicon",
};
